import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import QButton from 'components/QButton';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import ScheduledTransactionFormAcme from 'components/Forms/ScheduledTransactionFormAcme';
import QPureComponent from 'QPureComponent';
import { withStyles } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const styles = (theme) => ({
  dialogContentPadding: {
    paddingTop: 0,
    paddingBottom: 20,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

class ScheduledTransactionEditDialog extends QPureComponent {

  constructor(props) {
    super(props);

    this.state = {
      isDirty: undefined,
      isSubmitted: undefined,
    };
  }

  render() {
    const { props } = this;
    const scheduledTxn = props.scheduledTransaction &&
      props.scheduledTransaction.toJS ? props.scheduledTransaction.toJS() : props.scheduledTransaction;
    const { classes } = props;
    return (
      <Dialog
        open={Boolean(scheduledTxn)}
        onClose={() => props.onClose && props.onClose(this.state.isDirty)}
        aria-labelledby="edit-recurrence-dialog"
      >
        <DialogTitle id="edit-recurrence-dialog-title">
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={() => props.onClose && props.onClose(this.state.isDirty)}
          >
            <CloseIcon />
          </IconButton>
          {scheduledTxn && scheduledTxn.id ? 'Edit Recurrence' : 'Create Recurrence'}
        </DialogTitle>
        <DialogContent className={classes.dialogContentPadding}>
          <ScheduledTransactionFormAcme
            scheduledTransaction={scheduledTxn}
            render={({ remove, submit, isDirty, isSubmitted }) => {
              this.setState({ isDirty, isSubmitted });
              this.deleteScheduledTransaction = remove;
              this.submitScheduledTransaction = submit;
              if (isSubmitted && props.onClose) {
                props.onClose(false);
              }
            }}
          />
        </DialogContent>
        <DialogActions>
          <QButton
            style={{
              position: 'absolute',
              left: 24,
            }}
            variant="icon"
            disabled={!scheduledTxn || !scheduledTxn.id}
            id="delete-recurrence"
            aria-label="delete-recurrence"
            onClick={() => {
              if (this.deleteScheduledTransaction) {
                this.deleteScheduledTransaction();
                if (props.onClose) {
                  props.onClose(false, true);
                }
              }
            }}
          >
            <DeleteOutlineIcon/>
          </QButton>
          <QButton
            id='cancel-recurrence'
            variant="outlined"
            onClick={() => props.onClose && props.onClose(this.state.isDirty)}
          >
            Cancel
          </QButton>
          <QButton
            id='create-update-recurrence'
            type="submit"
            variant="contained"
            disabled={!this.state.isDirty}
            onClick={() => {
              if (this.submitScheduledTransaction) {
                this.submitScheduledTransaction();
              }
            }}
          >
            {scheduledTxn && scheduledTxn.id ? 'Update' : 'Create'}
          </QButton>
        </DialogActions>
      </Dialog>
    );
  }
}

ScheduledTransactionEditDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  scheduledTransaction: PropTypes.object,
  onClose: PropTypes.func,
};

export default withStyles(styles)(ScheduledTransactionEditDialog);
